import React from 'react';

interface MorphingLogoProps {
    height?: string;
    className?: string;
}

export const MorphingLogo: React.FC<MorphingLogoProps> = ({ height = '32px', className = '' }) => {
    return (
        <div
            className={className}
            style={{
                position: 'relative',
                height,
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <style>
                {`
                    @keyframes logoMorphGlow {
                        0%, 100% {
                            opacity: 1;
                            filter: drop-shadow(0 0 0px rgba(58, 106, 122, 0));
                        }
                        50% {
                            opacity: 0;
                            filter: drop-shadow(0 0 8px rgba(58, 106, 122, 0.6));
                        }
                    }
                    @keyframes logoMorphGlowReverse {
                        0%, 100% {
                            opacity: 0;
                            filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.4));
                        }
                        50% {
                            opacity: 1;
                            filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.6));
                        }
                    }
                    @keyframes softPulseGlow {
                        0%, 100% {
                            filter: drop-shadow(0 0 2px rgba(58, 106, 122, 0.3));
                        }
                        50% {
                            filter: drop-shadow(0 0 8px rgba(58, 106, 122, 0.5));
                        }
                    }
                `}
            </style>
            {/* Primary logo (teal pin) */}
            <img
                src="/assets/realsignal-logo-solo.png"
                alt="RealSignal"
                style={{
                    height,
                    width: 'auto',
                    position: 'absolute',
                    animation:
                        'logoMorphGlow 12s ease-in-out infinite, softPulseGlow 4s ease-in-out infinite',
                }}
            />
            {/* Secondary logo (white text) */}
            <img
                src="/assets/realsignal-logo-solo-white.png"
                alt="RealSignal"
                style={{
                    height,
                    width: 'auto',
                    position: 'absolute',
                    animation: 'logoMorphGlowReverse 12s ease-in-out infinite',
                }}
            />
            {/* Invisible spacer to maintain layout */}
            <img
                src="/assets/realsignal-logo-solo.png"
                alt=""
                style={{
                    height,
                    width: 'auto',
                    visibility: 'hidden',
                }}
            />
        </div>
    );
};

export default MorphingLogo;
